import React, { useState, useMemo, useEffect } from 'react';
import { Checkbox, Table as AntdTable } from 'antd';
import './styles.scss';

const HiddenColumnsTable = ({ columns, dataSource, rowClickFunction, filterParam }) => {
  const [checkedList, setCheckedList] = useState(columns.map((item) => item.key));
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const options = columns
    .filter(column => !column.hideCheckbox) // Only include columns that don't have hideCheckbox set to true
    .map(({ key, title }) => ({
      label: title,
      value: key,
    }));

  const updatedColumns = useMemo(() => [
    {
      title: '',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      width: '4%',
      render: (text, record, index) => ((currentPage - 1) * perPage) + index + 1,
    },
    ...columns,
  ], [currentPage, perPage, columns]);

  const newColumns = updatedColumns.map((item) => ({
    ...item,
    hidden: !checkedList.includes(item.key) && item.key !== 'rowIndex', // Keep index column always visible
  }));

  return (
    <>
      <div className="chart-table-separator"></div>
      <div className="columns-selection-area">
        <Checkbox.Group
          value={checkedList}
          options={options}
          onChange={(value) => {
            setCheckedList(value);
          }}
        />
      </div>
      <div className="hidden-columns-table-container">
        <AntdTable
          columns={newColumns.filter(col => !col.hidden)}
          dataSource={dataSource}
          onRow={(record) => ({
            onClick: () => rowClickFunction(record),
          })}
          style={{ marginTop: 16, width: '100%' }}
          scroll={{ x: 'max-content' }}
          pagination={{
            current: currentPage,
            pageSize: perPage,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPerPage(pageSize);
            },
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
          }}
        />
      </div>
    </>
  );
};

export default HiddenColumnsTable;